<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  props: ["language"],
  created(){
    this.$store.commit("setLanguage",this.language);
    let ln = this.language == "en" ? "en/" : "";
    let base = `https://www.uma.pt/${ln}`;
    const baseBreadcrumb = [
        { ID: 1, text: "Homepage", href: base },
        { ID: 2, text: this.$translate("UMA_LANG_HOMEPAGE_SOBRE"), href: `${base}sobre` },
        { ID: 3, text: this.$translate("UMA_LANG_SERVICOSADMINISTRATIVOS"), href: `${base}sobre/servicos-administrativos` },
        { ID: 4, text: this.$translate("UMA_LANG_UAA_SIGLASP"), route: { to: "/" } },
    ];
    this.$store.commit("setBreadcrumb",baseBreadcrumb);
  },
  provide(){
    return {
      lang: this.language
    }
  }
}
</script>

<style>
@font-face {
  font-family: "Montserrat Bold";
  src: url("./assets/fonts/Montserrat-Bold.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Light";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Light.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Regular.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat SemiBold";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-SemiBold.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat Thin";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Thin.otf") format("opentype");
}

@font-face {
  font-family: "PT Sans";
  /*src: url("./assets/fonts/PTS55F.ttf");*/
  src: url("./assets/fonts/PTSans.woff2") format('woff2');
}

@font-face {
    font-family: "PT Sans Bold";
    src: url("./assets/fonts/PTS75F.ttf");
}

@font-face {
  font-family: "PT Sans Italic";
  /*src: url("./assets/fonts/PTS76F.ttf");*/
  src: url("./assets/fonts/PTSansItalic.woff2") format('woff2');
}


@font-face {
  font-family: "PT Sans Bold Italic";
  /*src: url("./assets/fonts/PTS76F.ttf");*/
  src: url("./assets/fonts/PTSansBoldItalic.woff2") format('woff2');
}

.breadCrumbPosition {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
}

#app {
  font-family: Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #fff;
}

.azul_site_background {
  background-color: #6eb7ec;
}

.azul_site_border {
  border-color: #6eb7ec;
}

.columns .columns {
  padding-left: 0;
  padding-right: 0;
}

.row .row{
  margin-right: 0 !important;
  margin-left: 0 !important;
}
</style>
